import wixData from 'wix-data'
 
import { session } from 'wix-storage'
import { formFactor, rendering } from 'wix-window'
import wixLocation from 'wix-location'
import wixSeo from 'wix-seo'

import { getSubjects, flattenTutorials, subjectsToOptions, sortTutorials, slideElementWithHeader } from 'public/utils'
import { pageApp } from 'public/Factor/pageApp' // '@noamsi/factorblocks2'
import { sendBi } from 'public/biModule'
import { timed } from 'public/Logger/timedLogger'

function mapData2UiState({ tutorialsFlattened, subjectsAsOptions }) {
    return {
        '#tutorials': {
            paths: {
                'tutorials': tutorialsFlattened
            }
        },
        '#sortDropdown': {
            paths: {
                'value': 'mostPopular'
            }
        },
        '#subjects': {
        	paths: {
        		'subjects': subjectsAsOptions,
                'selectedSubjects': []
        	}
        },
    }
}

const eventHandles = {
    '#subjects': {
    	'onChange': (pageApp, [event]) => {
            updateTutorials()
            wixLocation.to(`/${wixLocation.path[0]}`)
        }
    },
    '#sortDropdown': {
        onChange: (pageApp, [event]) => {
            const { id, value } = event.target
            pageApp.setState(`#${id}.paths.value`, value)
            updateTutorials()
        }
    },
    '#loadMore': {
        onClick: async () => {
            await $w('#loadMore').collapse()
            updateTutorials()
        }
    }
}

$w.onReady(async function () {
    await timed('Tutorials Page', async () => {
        const [subjects, tutorials] = await Promise.all([getPageSubjects(), getTutorials()])

        const subjectsAsOptions = subjectsToOptions(subjects)
        const tutorialsFlattened = flattenTutorials(tutorials)

        pageApp.start({ tutorialsFlattened, subjectsAsOptions, subjects }, mapData2UiState, eventHandles)

        handlePreSelectedSubject(subjects, wixLocation.path[1])
        
        updateTutorials()

        if (rendering.env === 'browser') {
            // slideElementWithHeader('#subjectsMenuSection')

            sendBi('pageOpen', {
                'sourcePage': session.getItem('previousPageName'),
                'name': session.getItem('currentPageName')
            })
        }
    }, { renderingEnv: rendering.env })
})

const getTutorials = async () => {
    const { items: tutorials } = await wixData.query('tutorials')
        .ne('unlisted', true)
        .include('subject')
        .find()

    return tutorials
}

const getPageSubjects = async () => {
    const subjects = await getSubjects()
    return subjects.filter(subject => (subject.hasTutorials))
}

const updateTutorials = () => {
    const tutorials = pageApp.getData().tutorialsFlattened

    const selectedSubjects = $w('#subjects').getSelectedSubjects()

    updateH1(selectedSubjects)

    const filtererdTutorials = filterTutorials(tutorials, selectedSubjects)

    const sortBy = $w('#sortDropdown').value
    let filtererdSortedTutorials = sortTutorials(filtererdTutorials, sortBy)

    if (!$w('#loadMore').collapsed) {
        const size = {
            'Desktop': 8,
            'Tablet': 6,
            'Mobile': 2
        } [formFactor]
        filtererdSortedTutorials = filtererdSortedTutorials.slice(0, size)
    }

    pageApp.setState('#tutorials.paths.tutorials', filtererdSortedTutorials)
}

function filterTutorials(tutorials, selectedSubjectIds) {
    return (selectedSubjectIds.length === 0) ?
        tutorials :
        tutorials.filter(tutorial => selectedSubjectIds.includes(tutorial.subjectId))
}

const handlePreSelectedSubject = (subjects, initialSubjectSlug) => {
    if (!initialSubjectSlug) return

    const subjectBySlug = subjects.find(subject => (subject.slug === initialSubjectSlug))
    pageApp.setState({ '#subjects.paths.selectedSubjects': [subjectBySlug._id] })
    updateTutorials()

    setSubjectSeoTitleAndDescription(subjectBySlug)
}

const updateH1 = (selectedSubjects) => {
    if (selectedSubjects.length === 1) {
        const selectedSubjectId = selectedSubjects[0]
        const { subjects } = pageApp.getData()
        const selectedSubject = subjects.find(subject => (subject._id === selectedSubjectId) )
        $w('#pageTitle').html = `<h1 class="font_2"><span>${selectedSubject.title} <span style="color:#166AEA">*</span>Tutorials</span></h1>`
    } else {
        $w('#pageTitle').text = 'Tutorials'
    }
}

const setSubjectSeoTitleAndDescription = (subject) => {
    const skillsFor = (subject.isNoun) ? 'skills for ' : ''
    const title = `Learn ${skillsFor}${subject.title} | Free Tutorials | Wix Learn`
    const description = `Get quick, hands-on guidance and deep dive into ${skillsFor}${subject.title} tutorials created by Wix Learn just for you!`
    
    wixSeo.setMetaTags([
        ...wixSeo.metaTags,
        { 'property': 'og:title', 'content': title },
        { 'property': 'og:description', 'content': description },
        { 'name': 'description', 'content': description }
    ])

    wixSeo.setTitle(title)
}